// Engelse teksten van aanmelden en abonnement (zie billingApp.nl.ts).
export const appBillingEn = {
    signup: {
        steps: ['Welcome', 'Account', 'Confirm', 'Household', 'Members', 'Modules', 'Board', 'Done'],
        stepOf: 'Step {n} of {total}: {name}',
        welcomeTitle: 'Welcome to AMUMIN Family Board',
        welcomeBody: 'A calm board for your household: the calendar, tasks and more, on a tablet on the wall and in this app.',
        trialLine: 'The first month is free. You don’t need to enter payment details now.',
        languageLabel: 'Which language would you like to continue in?',
        start: 'Get started',
        closedTitle: 'Sign-up is not open yet',
        closedBody: 'We are opening soon. Join the waiting list and we will send you an invitation.',
        closedLink: 'Go to the waiting list',
        haveAccount: 'Already have an account?',
        login: 'Log in',
        accountTitle: 'Your account',
        accountBody: 'You use this to log in. We only use your e-mail address for your account, never for advertising.',
        name: 'Your first name',
        nameHint: 'This is what the board calls you. You can change it later.',
        nameRequired: 'Enter your first name.',
        email: 'E-mail address',
        method: 'How would you like to log in?',
        methodPassword: 'With a password',
        methodLink: 'E-mail me a link',
        methodLinkHint: 'You get a code and a button by e-mail. You can always choose a password later.',
        priceLine: '1 month free, then {price} per month. You can cancel at any time.',
        priceLinePlaceholder: '1 month free, then you pay monthly. You will hear the price well before the end. You can cancel at any time.',
        termsBefore: 'I agree to the',
        termsLink: 'terms',
        termsAnd: 'and the',
        privacyLink: 'privacy statement',
        termsRequired: 'Tick this box to continue.',
        createAccount: 'Create account',
        verifyTitle: 'Confirm your e-mail address',
        verifyIntro: 'We sent a code to {email}. Type it below, or click the button in the e-mail.',
        verifyHint: 'No e-mail? Check your spam folder too, or request a new code below.',
        otherEmail: 'Different e-mail address',
        linkBusy: 'Confirming your e-mail address…',
        linkVerifiedTitle: 'Your e-mail address is confirmed',
        linkVerifiedBody: 'Your free month has started. Continue in the browser where you began, or log in here.',
        linkInvalid: 'This link has expired or has already been used. Log in, or sign up again.',
        modulesTitle: 'What would you like to use?',
        modulesBody: 'Everything is optional. For your type of household, these are already on; turn on or off whatever you like. You can always change this later in Settings › Modules.',
        profileTitle: 'Faith, food and special days',
        profileBody: 'Only if you want to. You choose yourself and give separate consent for it.',
        profileButton: 'Choose',
        boardTitle: 'A tablet as your board',
        boardBody: 'Put a tablet on the wall and link it with the QR code. No tablet at hand? You can also do this later in Settings › Tablets.',
        boardQr: 'Link with QR code',
        boardCode: 'Link with a code',
        doneTitle: 'Welcome, everything is ready',
        doneTrial: 'Your free month runs until and including {date}.',
        doneNext: [
            'We will send you a reminder a week before the end.',
            'Want to continue after that? Add your payment details in Settings › Subscription. If you do nothing, you can still view everything, but no longer change anything.',
            'You can cancel at any time. We never delete anything automatically.',
        ],
        toApp: 'Go to the app',
    },
    page: {
        title: 'Subscription',
        settingsHint: 'Free month, payment and invoices',
        offTitle: 'No subscriptions yet',
        offBody: 'You are using AMUMIN Family Board without a subscription for now.',
        noneTitle: 'No subscription needed',
        noneBody: 'This family board has no subscription.',
        status: {
            trial: 'Free month',
            active: 'Active',
            past_due: 'Payment failed',
            paused: 'Paused',
            cancelled: 'Cancelled',
            expired: 'View only',
        },
        trialLeft: '{n} more free days, until and including {date}.',
        trialLastDay: 'Today ({date}) is your last free day.',
        activeUntil: 'Paid until {date}.',
        activeOpen: 'Your subscription is running.',
        cancelledUntil: 'Cancelled. Everything keeps working until and including {date}.',
        expiredBody: 'Your free month is over. Everything is still there; you can make changes again after paying.',
        pastDueBody: 'The last payment failed. Add your payment details again.',
        pausedBody: 'AMUMIN has paused your subscription for a while. Everything works as usual.',
        plan: 'Plan',
        perMonth: '{price} per month',
        pricePlaceholder: 'Price to follow',
        payment: 'Payment details',
        paymentNone: 'No payment details yet.',
        paymentSet: 'Direct debit is set up.',
        addPayment: 'Add payment details',
        soon: 'Coming soon: pay with iDEAL, then by direct debit.',
        checkoutTitle: 'Add payment details',
        checkoutBody: 'You pay the first month with iDEAL. After that, we charge you automatically every month. You can cancel at any time.',
        startNow: 'I want the service to continue straight away. If I withdraw within 14 days, I only pay for the days I have already used.',
        startNowRequired: 'Tick this box to continue.',
        toPayment: 'Go to payment',
        checkoutOpen: 'A payment is already in progress. Finish it first, or try again in an hour.',
        paidReturn: 'Thank you. As soon as the payment comes in, you will see it here.',
        invoices: 'Invoices',
        invoicesNone: 'No invoices yet.',
        invoiceStatus: {
            open: 'Open',
            paid: 'Paid',
            failed: 'Failed',
            refunded: 'Refunded',
            void: 'Void',
        },
        invoiceLine: '{number} · {period} · {amount}',
        cancel: 'Cancel subscription',
        cancelTitle: 'Cancel subscription?',
        cancelBody: 'Everything keeps working until and including {date}. After that, you can still view everything, but no longer change anything. We delete nothing.',
        cancelConfirm: 'Yes, cancel',
        keep: 'Keep it',
        cancelDone: 'Your subscription has been cancelled.',
        resume: 'Continue after all',
        resumeDone: 'Good, your subscription continues.',
        onlyOwner: 'Only the owner can pay or cancel.',
        deleteHint: 'Want to delete everything? You can do that in Settings › Your data.',
    },
    banner: {
        expiredTitle: 'Your free month is over',
        expiredBody: 'You can still view everything. Add payment details to add and change things again.',
        pay: 'Pay',
        readOnly: 'Your free month is over: you can make changes again after paying.',
    },
    terms: {
        title: 'Terms (draft)',
        intro: 'This is a draft. The final general terms and conditions will be here before sign-up opens.',
        points: [
            'The first month is free. You don’t need to give payment details for it.',
            'After that, you pay monthly or yearly, in advance. You can cancel at any time; it then runs until the end of the paid period.',
            'After the free month without payment, you can still view everything, but no longer change anything. We never delete anything automatically.',
            'As a consumer, you have a 14-day right of withdrawal from the moment you start paying.',
            'How we handle your data is described in the privacy statement.',
        ],
    },
};
//# sourceMappingURL=billingApp.en.js.map